import { DateTime } from "luxon"
import { displayMessage } from "../../../services/helper"


export default (enums) => {

    return (
        [
            {
                field: 'monitor',
                headerName: displayMessage('MONITOR'),
                width: 300,
                valueGetter: function (params) {
                    return `${params.row?.Monitor?.first_name || ''} ${params.row?.Monitor?.last_name || ''}`
                }
            },
            {
                field: 'status_formatted',
                headerName: displayMessage('STATUS'),
                width: 150
            },
            {
                field: 'status_begin',
                headerName: displayMessage('START'),
                width: 150,
                headerAlign: 'center',
                sortable: false,
                align: 'center',
                valueFormatter: (params) => {
                    if (!params?.value) {
                        return ''
                    }
                    const data = DateTime.fromISO(params.value);
                    return data.toFormat('dd/MM/yyyy')
                }
            },
            {
                field: 'status_end',
                headerName: displayMessage('END'),
                width: 150,
                headerAlign: 'center',
                sortable: false,
                align: 'center',
                valueFormatter: (params) => {
                    if (!params?.value) {
                        return ''
                    }
                    const data = DateTime.fromISO(params.value)
                    return data.toFormat('dd/MM/yyyy')
                }
            },
            {
                field: 'duration',
                headerName: displayMessage('DURATION'),
                width: 250,
                valueGetter: function (params) {
                    return params.row?.duration ? `${parseFloat(params.row?.duration).toFixed(2)} minutos` : ''
                }
            },
        ]
    )
}
